export type PwaUpdate = () => Promise<void>;

type Listener = (update: PwaUpdate | null) => void;

let current: PwaUpdate | null = null;
const listeners = new Set<Listener>();

export function publishPwaUpdate(update: PwaUpdate): void {
  current = update;
  for (const listener of listeners) listener(update);
}

export function clearPwaUpdate(): void {
  current = null;
  for (const listener of listeners) listener(null);
}

export function subscribePwaUpdate(listener: Listener): () => void {
  listeners.add(listener);
  listener(current);
  return () => {
    listeners.delete(listener);
  };
}
